import { Routes, Route, Navigate } from 'react-router-dom'
import DancerView from './components/DancerView.jsx'
import InstructorView from './components/InstructorView.jsx'
import SpotifyCallback from './components/SpotifyCallback.jsx'
import NotFound from './components/NotFound.jsx'

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<DancerView />} />
      <Route path="/instructor" element={<InstructorView />} />
      <Route path="/auth/callback" element={<SpotifyCallback />} />
      <Route path="/main" element={<Navigate to="/?room=main" replace />} />
      <Route path="/late" element={<Navigate to="/?room=late" replace />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}
